
import { PADebug } from "./PADebug"
import { ArticleGW } from "./ArticleGW"


/*  The ArticleGroupGW class functions as a collection of articles, labeled by a Nobb identifier and
 *  has a describing title. Several groups may refer to the same sets of articles, which are not ever
 *  duplicates even though they occur in different groups, and may be aswell sorted differently within
 *  different grups. The idea is to make the data available as fast as possible, with a minimum of
 *  sorting or instantiating needed to take place whenever a cathegory or sorted set of articles are requested.
 *  the group's level in a nobb hierarchy is given by m_level. */
export class ArticleGroupGW {
    constructor(groupIDMin: string, groupIDMax: string, title: string, level: number, alphaPos:string) {
        this.m_groupIdentifierMin = groupIDMin
        this.m_groupIdentifierMax = groupIDMax
        this.m_groupTitle = title
        this.m_level = level
        this.m_articles = new Array<ArticleGW>()
        this.m_loadedStatus = { status: 0 }
        this.m_groupAlphaPos = alphaPos
        this.m_isLastBornFlags = 0
    }

    private m_groupIdentifierMin: string
    private m_groupIdentifierMax: string
    private m_groupTitle: string
    private m_level: number
    private m_articles: Array<ArticleGW>
    private m_loadedStatus: { status: number }
    private m_groupAlphaPos: string
    private m_isLastBornFlags: number

    // Checking if a group identifier is this group or a child group
    doesInclude(identifier: string) {
        if (identifier < this.m_groupIdentifierMin) {
            return false
        }

        if (identifier > this.m_groupIdentifierMax) {
            return false
        }
        
        return true
    }

    // Adds an article to the end of the group's array
    insert(article: ArticleGW) {
        this.m_articles.push(article)
    }

    // Replaces whatever articles this group holds with an array reference
    setArticles(arrayOfArticles: Array<ArticleGW>) {
        this.m_articles = arrayOfArticles
    }

    // returns the amount of articles within this group
    getAmount() {
        return this.m_articles.length
    }

    // Access Last L2 child of L1 group
    SetLastBorn(isLastBorn: boolean, mode: number) {
        var currentAlphaGlobalState = this.m_isLastBornFlags & 1
        var currentHierarchyGlobalState = this.m_isLastBornFlags & 2
        var currentLocalState = this.m_isLastBornFlags & 4

        if (mode == 100) { // Alphabetical groups globally
            if (isLastBorn == true) {
                currentAlphaGlobalState = 1
            }
            else {
                currentAlphaGlobalState = 0
            }
        }

        if (mode == 101) {// Hierarchial groups globally
            if (isLastBorn == true) {
                currentHierarchyGlobalState = 2
            }
            else {
                currentHierarchyGlobalState = 0
            }
        }

        if (mode == 102) {// Pricebook local Groups
            if (isLastBorn == true) {
                currentLocalState = 4
            }
            else {
                currentLocalState = 0
            }
        }
        
        this.m_isLastBornFlags = currentAlphaGlobalState | currentHierarchyGlobalState | currentLocalState
    }

    // Access Last L2 child of L1 group
    IsLastBorn(mode: number) {
        if (mode == 100) { // Alphabetical groups globally
            return ((this.m_isLastBornFlags & 1)==1)?true:false
        }

        if (mode == 101) {// Hierarchial groups globally
            return ((this.m_isLastBornFlags & 2) == 2) ? true : false
        }

        if (mode == 102) {// Local group in pricebook
            return ((this.m_isLastBornFlags & 4) == 4) ? true : false
        }

        PADebug.Assert(false, "ArticleGroupGW.IsLastBorn - given mode was unexpected! mode:" + mode.toString())
        return false
    }

    // Synchronize makes this group hold the same articles as a target group.
    synchronize(target: ArticleGroupGW) {
        this.m_articles = target.m_articles
        this.m_loadedStatus = target.m_loadedStatus
    }

    // returns the description title string
    GetDescription() {
        return this.m_groupTitle
    }

    // returns the word used for sorting groups alphabetically
    GetAlphaPos() {
        return this.m_groupAlphaPos
    }

    // Returns the minimum value of this group's nobb scoope
    GetIDMin() {
        return this.m_groupIdentifierMin
    }

    // Returns the maximum value of this group's nobb scoope
    GetIDMax() {
        return this.m_groupIdentifierMax
    }

    // Returns the identifier of this group
    GetGroupID() {
        return this.m_groupIdentifierMin
    }

    // Returns the level of this group
    GetLevel() {
        return this.m_level
    }

    // returns a reference to this group's articles
    GetArticles() {
        return this.m_articles
    }

    // Accessing a reference to the object embedded value for this group's loading status
    GetLoadedStatus() {
        return this.m_loadedStatus
    }

    // Access : loaded status
    SetLoadedStatus(newStatus: { status: number }) {
        this.m_loadedStatus = { status: newStatus.status }
    }

    // Default sorting algorithm for article groups
    SortOwnArticles() {
        this.m_articles.sort(function (a, b) {
            var x = a.GetDescription()
            var y = b.GetDescription();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            x = a.GetDescription2();
            y = b.GetDescription2();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        })
    }
}


// WEBPACK FOOTER //
// ./client/view/ArticleGroupGW.tsx